module.exports = __webpack_public_path__ + "static/media/city.36ece23b.svg";